import patientsListReducer from "./patientReducer";
import authGroupReducer from "./authReducer";
import monthlyReportReducer from "./monthlyReportReducer";
const reducers = {
  patientsListStore: patientsListReducer,
  authGroupStore: authGroupReducer,
  monthlyReportStore: monthlyReportReducer
};
export default reducers;
